var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.35.667A1.725 1.725 0 0 0 .678 2.256L.668 9.61a1.73 1.73 0 0 0 1.724 1.724h11.213c.947 0 1.729-.778 1.729-1.724l-.005-7.338A1.733 1.733 0 0 0 13.605.667H2.35Zm12.317 2.469V9.61c0 .583-.477 1.057-1.062 1.057H2.392A1.057 1.057 0 0 1 1.335 9.61V3.147l5.687 5.682a1.413 1.413 0 0 0 1.948 0l5.697-5.693Z",
  fill: "currentColor"
})));

export default SvgIconEmail;